export const PLACEHOLDER_EMAIL = 'atualize@'
